import { ReactNode } from 'react';

// eslint-disable-next-line @typescript-eslint/no-restricted-imports
import { Typography, makeStyles } from '@material-ui/core';

const useStyles = makeStyles({
  item: {
    '& + &::before': {
      content: "'\\2022'",
      margin: '0 0.3em',
    },
  },
});

type MetadataTextProps = {
  items: ReactNode[];
  className?: string;
};

export const MetadataText = ({ items, className }: MetadataTextProps) => {
  const classes = useStyles();

  const filtered = items.filter(
    item =>
      item !== null && item !== undefined && item !== '' && item !== false,
  );

  if (filtered.length === 0) return null;

  return (
    <Typography
      variant="caption"
      color="textSecondary"
      component="div"
      className={className}
    >
      {filtered.map((item, index) => (
        <span key={index} className={classes.item}>
          {item}
        </span>
      ))}
    </Typography>
  );
};
